import Colors from '@/constants/Colors';

export default function buildColorTokensCss() {
  return `:root {
  --color-text: ${Colors.text};
  --color-text-dark: ${Colors.textDark};
  --color-primary: ${Colors.primary};
  --color-background: ${Colors.background};
}
`;
}
